import { gql } from "@apollo/client";
import uuid from "react-uuid";
import { fetchLang } from '@util/http';

// 新增版式
export const CREATE_HOME_BASE= gql`
  mutation _CREATE_HOME_BASE($homeBase:HomeBaseInput){
    create_home_base(homeBase:$homeBase){
      success
      result
      error
      info   
    }
  }
`
// 新增版式
export const BATCH_CREATE_HOME_BASE= gql`
  mutation _BATCH_CREATE_HOME_BASE($homeBases:[HomeBaseInput]){
    batch_create_home_bases(homeBases:$homeBases){
      success
      result
      error
      info   
    }
  }
`

// 修改版式
export const UPDATE_HOME_BASE= gql`
  mutation _UPDATE_HOME_BASE($homeBase:HomeBaseInput){
    update_home_base(homeBase:$homeBase){
      success
      result
      error
      info   
    }
  }
`

// 修改版式
export const MOVE_HOME_BASE_NO= gql`
  mutation _UPDATE_HOME_BASE($id:String, $step:Int ){
    move_home_base_no(id:$id, step:$step){
      success
      result
      error
      info   
    }
  }
`

// 删除版式
export const DELETE_HOME_BASE= gql`
  mutation _DELETE_HOME_BASE($id:String){
    delete_home_base(id:$id){
      success
      result
      error
      info   
    }
  }
`

// 按id查询单个版式
export const QUERY_HOME_BASE_BY_ID= gql`
  query _QUERY_HOME_BASE_BY_ID($id:String){
    query_home_base_by_id(id:$id){
      success
      result
      error
      info    
    }
  }
`

// 条件查询版式
export const QUERY_HOME_BASE= gql`
  query _QUERY_HOME_BASE($con:QueryHomeBaseInput){
    query_home_base(con:$con){
      success
      result
      error
      info
    }
  }
`

// 修改个人 私域背景图片
export const UPDATEBGURL= gql`
  mutation _UPDATEBGURL($teamId:String, $uid: String!, $bgUrl: String!, $light: Int, $bgConfigJson:String){
    updateBgUrl(teamId:$teamId, uid:$uid, bgUrl:$bgUrl, light: $light, bgConfigJson: $bgConfigJson){
      result 
    }
  }
`
// 查询个人 私域背景图片
export const QUERYBGURL= gql`
  query _QUERYBGURL($teamId: String, $uid: String!){
    queryBgUrl(teamId:$teamId, uid:$uid,){
      result
    }
  }
`

const headers = {
	"content-type": "application/json"
}


// 工具接口：生成二维码
export function generateQRCode(params) {
	return fetchLang('/api/util/generateQRCode', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}



// 工具接口：解析二维码信息
export function parseQrCode(params) {
	return fetchLang('/api/util/parseQRCode', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// .获取分享二维码和链接地址
export const SHARE_WORK= gql`
  mutation _SHARE_WORK($workIds:[String], $clientId: String, $clientType: Int, $tab:Int, $curInfo:Object, $addMark:Boolean, $fold:Int,$expirationTime:String) {
    shareWork(workIds:$workIds,clientId:$clientId,clientType:$clientType,tab:$tab,curInfo:$curInfo,addMark:$addMark,fold:$fold,expirationTime:$expirationTime) {
      success
      result
      error
      info   
    }
  }
`
//作品分享
export function WORK_SHARE_WORK(params) {
	return fetchLang('/api/work/shareWork', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

//介绍分享
export function homeBaseShareWork(params) {
	return fetchLang('/api/homeBase/shareWork', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 获取分享的作品数据
// export function getVisitWork(params,key) {
// 	return fetchLang(`/api/visit/getVisitWork?key=${key ?? ''}&clientId=${params?.clientId ?? ''}&clientType=${params?.clientType ?? ''}`, {
// 		method: "POST",
// 		headers,
// 		// body: JSON.stringify(params)
// 	}).then(res => res.json())
export function getVisitWork(params) {
	return fetchLang(`/api/visit/getVisitWork`, {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}
export function uploadWithQuality(params) {
	return fetchLang('/api/uploadWithQuality', {
		method: "POST",
		body: params
	}).then(res => res.json())
}
// 压缩图片
export function compress_image(params) {
	return fetchLang('/api/compress_image', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
  }).then(res => res.json())
}

//批量上传
export function multipartUpload(params) {
	return fetchLang('/api/multipartUpload', {
		method: "POST",
		body: params
	}).then(res => res.json())
}

// 设置私域配置
export const UPDATE_HOME_BASE_CONFIG= gql`
  mutation _UPDATE_HOME_BASE_CONFIG($homeBaseConfig:HomeBaseConfigInput){
    update_home_base_config(homeBaseConfig:$homeBaseConfig){
      success
      result 
      success
      info 
    }
  }
`
// 查询私域配置
export const QUERY_HOME_BASE_CONFIG= gql`
  query _QUERY_HOME_BASE_CONFIG($con: HomeBaseConfigInput){
    query_home_base_config(con:$con){
      success
      result{
        id
        clientId
        clientType
        contentDisplay
        subFontItemList
        tmCreate
        tmModify
        introductionContentType
        webIntroductionIframeUrl
        h5IntroductionIframeUrl
        defaultNavigateDisplayH5
      }
    }
  }
`

// 删除版式
export const SET_PRIVATE_OPEN_STATE= gql`
  mutation _SET_PRIVATE_OPEN_STATE($teamId:String!,$privateOpenState:Int!){
    set_private_open_state(teamId:$teamId,privateOpenState:$privateOpenState){
      success
      result
      error
      info   
    }
  }
`
//更新收藏的已读状态 个入库
export function readUpdate(params) {
	return fetchLang('/api/share/readUpdate', {
		method: "POST",
    headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 查询作品卡片列表(支持分页）
export function queryNewWorkByCon(params) {
	return fetchLang('/api/work/queryNewWorkByCon', {
		method: "POST",
    headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 查询作品筛选页参数
export function queryFilterParam(params) {
	return fetchLang('/api/work/queryFilterParam', {
		method: "POST",
    headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 用户是否第一次访问某模块
export function user_first_visit_unify(type) {
	return fetchLang(`/api/user_first_visit_unify?type=${type}&uid=${uuid()}`, {
		method: "GET",
	}).then(res => res.json())
}
// 取消用户第一次访问某模块标识
export function cancel_user_first_visit_unify(type) {
	return fetchLang(`/api/cancel_user_first_visit_unify?type=${type}`, {
		method: "GET",
	}).then(res => res.json())
}
// 查询作品的照片墙
export function queryDisplayAlbum(params) {
	return fetchLang('/api/work/queryDisplayAlbum', {
		method: "POST",
    headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 获取app版本
export function queryNewestAppVersion() {
	return fetchLang(`/api/appVersion/queryNewestAppVersion?versionsType=`, {
		method: "GET",
	}).then(res => res.json())
}
// 根据前缀查询团队信息
export function teamInfoByUrl(prefix) {
	return fetchLang(`/api/team/teamInfoByUrl?prefix=${prefix}`, {
		method: "GET",
	}).then(res => res.json())
}
//预览作品
export function previewShareWork(params) {
	return fetchLang('/api/work/previewShareWork', {
		method: "POST",
    headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}
//ai历史记录
export function pageHistoryAI(params) {
	return fetchLang('/api/chatAI/pageHistory', {
		method: "POST",
    headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 排队人数
export function AIQueueSize(msgId) {
	return fetchLang(`/api/chatAI/queueSize?msgId=${msgId}`, {
		method: "GET",
	}).then(res => res.json())
}

export function isUserOnQueueing() {
	return fetchLang(`/api/chatAI/isUserOnQueueing`, {
		method: "GET",
	}).then(res => res.json())
}
//彩色图像转灰度图像
export function color_to_gray_image(params) {
	return fetchLang('/api/color_to_gray_image', {
		method: "POST",
    headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}
// 条件查询委托资材列表
export function queryByCon(params) {
	return fetchLang('/api/entrust/queryByCon', {
		method: "POST",
    headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 分享主页+资材
export function shareProduct(params) {
	return fetchLang('/api/product/shareProduct', {
		method: "POST",
    headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

export function generateSharingCard(params) {
	return fetchLang('/api/wechat/generateSharingCard', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

export function addToCart(params) {
	return fetchLang('/api/shopping-cart/addToCart', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}


// 分享店铺
export function shareTeamShop(params) {
	return fetchLang('/api/team/shareTeamShop', {
		method: "POST",
    headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 查询视频信息列表 /api/teamVideo/queryByTeamId
export function queryByTeamId(params) {
	return fetchLang('/api/teamVideo/queryByTeamId', {
		method: "POST",
    headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 删除视频信息 delTeamVideo
export function delTeamVideo(params) {
	return fetchLang('/api/teamVideo/delete', {
		method: "POST",
    headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 查询单个视频信息 /api/teamVideo/queryById
export function queryByIdVideo(params) {
	return fetchLang('/api/teamVideo/queryById', {
		method: "POST",
    headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 保存视频信息  /api/teamVideo/save
export function saveVideo(params) {
	return fetchLang('/api/teamVideo/save', {
		method: "POST",
    headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 新增大纲 /api/homebase/outline/create
export function createOutline(params) {
  return fetchLang('/api/homebase/outline/create', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 修改大纲 /api/homebase/outline/update
export function updateOutline(params) {
  return fetchLang('/api/homebase/outline/update', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 删除大纲 /api/homebase/outline/delete
export function deleteOutline(params) {
  return fetchLang('/api/homebase/outline/delete', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 查询大纲 /api/homebase/outline/query
export function queryOutline(params) {
  return fetchLang('/api/homebase/outline/query', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 查询大纲 /api/homebase/outline/query
export function queryOutlineById(params) {
  return fetchLang('/api/homebase/outline/queryById', {
    method: "POST",
    headers,
    body:JSON.stringify(params)
  }).then(res => res.json())
}

// 移动大纲 /api/homebase/outline/move
export function moveOutline(params) {
  return fetchLang('/api/homebase/outline/move', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 移动版式 /api/homebase/move
export function moveTem(params) {
  return fetchLang('/api/homebase/move', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 批量修改版式/api/homebase/batchUpdate
export function updateTems(params) {
  return fetchLang('/api/homebase/batchUpdate', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 获取图片是否为纯色 /api/imageTool/detectImageBase
export function detectImageBase(params) {
  return fetchLang('/api/imageTool/detectImageBase', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 获取会话id 进入页面获取一个作为埋点的id-分享统计时辰
export function getSessionId() {
  return fetchLang('/api/util/session', {
    method: "GET",
  }).then(res => res.json())
}

// 埋点接口-分享统计时辰
export function point(params) {
  return fetchLang('/api_point/add', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 根据分享链接Key查询埋点下内容数据总览
export function queryTotal(params) {
  return fetchLang('/api_point/queryTotalCount', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}

// 根据内容id查询数据每日时长
export function queryTotalDetail(params) {
  return fetchLang('/api_point/queryDetail', {
    method: "POST",
    headers,
    body: JSON.stringify(params)
  }).then(res => res.json())
}


// 获取品牌类型
export function getBrandSourceType() {
  return fetchLang('/api/brandSourceType/getAll', {
    method: "GET",
  }).then(res => res.json())
}

// 查询团队tab，covers等信息
// 共享缓存 + 请求合并：管理端多个组件（team_home / private_header / directory_set /
// main_cover / teamPress / international useData）会在同一页面挂载时对相同参数重复请求该接口。
// 响应含 mlNickName 等全语言结构，不随 Accept-Language 变化，缓存 key 用 teamId:clientType 即可。
// 配置更新后需调用 invalidateHomeBaseConfigCache 主动失效。
const homeBaseConfigCache = new Map();
const homeBaseConfigPending = new Map();
const HOME_BASE_CONFIG_CACHE_TTL = 30 * 1000;
const homeBaseConfigKey = (params) => {
  if (!params?.teamId) return null;
  return `${params.teamId}:${params.clientType ?? 2}`;
};

export function invalidateHomeBaseConfigCache(teamId) {
  if (teamId) {
    const prefix = `${teamId}:`;
    [...homeBaseConfigCache.keys()].forEach((key) => {
      if (key.startsWith(prefix)) homeBaseConfigCache.delete(key);
    });
    return;
  }
  homeBaseConfigCache.clear();
}

export function findHomeBaseConfigInfo(params) {
  const key = homeBaseConfigKey(params);
  // 无 teamId 的场景不缓存，直接请求
  if (!key) return rawFindHomeBaseConfigInfo(params);

  const cached = homeBaseConfigCache.get(key);
  if (cached && Date.now() - cached.timestamp < HOME_BASE_CONFIG_CACHE_TTL) {
    return Promise.resolve(cached.value);
  }
  // 并发合并：相同 key 的进行中请求复用同一个 Promise
  if (homeBaseConfigPending.has(key)) return homeBaseConfigPending.get(key);

  const request = rawFindHomeBaseConfigInfo(params)
    .then((res) => {
      homeBaseConfigCache.set(key, { timestamp: Date.now(), value: res });
      homeBaseConfigPending.delete(key);
      return res;
    })
    .catch((err) => {
      homeBaseConfigPending.delete(key);
      throw err;
    });
  homeBaseConfigPending.set(key, request);
  return request;
}

function rawFindHomeBaseConfigInfo(params) {
  return fetchLang('/api/homeBase/findHomeBaseConfigInfo?' + new URLSearchParams(params).toString(), {
    method: "GET",
  }).then(res => res.json())
}